export default "__VITE_ASSET__$YCCBY0J__"